// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.header-form[data-v-44d79478],\n.inputs[data-v-44d79478],\n.actions[data-v-44d79478] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.actions[data-v-44d79478] {\n  height: 42px;\n}\n@media (max-width: 600px) {\n.inputs[data-v-44d79478],\n  .actions[data-v-44d79478] {\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
